import { LoadingOverlay, Stack } from '@mantine/core';
import React from 'react';

import { useConfig } from '@portals/api/partners';

import { Members } from './Members';
import { SupportCenter } from './SupportCenter';
import { SupportSeats } from './SupportSeats';

export function Support() {
  const config = useConfig();

  return (
    <>
      <LoadingOverlay visible={config.isLoading} />

      {config.isFetched ? (
        <Stack spacing="xl" maw={760}>
          <SupportCenter />

          <SupportSeats />

          <Members />
        </Stack>
      ) : null}
    </>
  );
}
